import "./index.scss";

import { SubscriptionPreferencesPage } from "./subscriptionPreferences/subscriptionPreferences/SubscriptionPreferencesPage";
import { screenLockerReducer } from "./subscriptionPreferences/_modules/screenLocker/screenLockerReducer";

export const userManagementModule = {
    pathPrefix: "userManagement",
    commonPartReducer: {
        someModuleSubState: (s = null, a) => s,
        screenLocker: screenLockerReducer,
    },
    pages: [SubscriptionPreferencesPage],
};
